import React, { useTransition } from "react";

import Box from "@mui/joy/Box";

import { Link } from "react-router-dom";
import { useGetImagesQuery } from "services/image/imageApi";
import { TaggedImage } from "constructs/TaggedImage";
import { Tag } from "constructs/Tag";

export type BannerTarget = string | number | undefined | "random";

export interface BannerProps {
  filter?: Array<Tag> | undefined;
  bannerTarget?: BannerTarget | undefined;
}

const Banner = (props: BannerProps) => {
  const { bannerTarget } = props;
  const { isFetching, isLoading, data: bannerOptions } = useGetImagesQuery({ kinds: "banner" });
  const [ isPending, startTranstion ] = useTransition();

  
  
  let banners: Array<TaggedImage> = React.useMemo(
    () => updateBanners(bannerOptions, props.filter),
    [bannerOptions, props.filter]
  );

  let currentBanner = React.useMemo(
    () => computeBanner(banners, bannerTarget),
    [banners, bannerTarget]
  );

  const [showBannerDetails, setShowBannerDetails] =
    React.useState<boolean>(false);

    if (isFetching && isLoading) {
      return null;
    }
  
    if (!bannerOptions) {
      return null;
    }

    if (!bannerOptions) {
      return null;
    }

  return (
    <Box
      onMouseEnter={() => setShowBannerDetails(true)}
      onMouseLeave={() => setShowBannerDetails(false)}
    >
      <div
        style={{
          ...currentBanner?.styles,
          position: "relative",
          minHeight: "240px",
          // url("https://tenkizora.com/images/posts/Tsuioku_no_Apeiron/Post001.jpg") 2x type("image/jpeg"),
          backgroundImage: `image-set(
            url("${currentBanner?.uri}/${currentBanner?.name}_${4800}x.avif") 2x type("image/avif"),
            url("${currentBanner?.uri}/${currentBanner?.name}_${4800}x.webp") 2x type("image/webp"),
            url("${currentBanner?.uri}/${currentBanner?.name}_${4800}x.jpg") 2x type("image/jpeg"),
            url("${currentBanner?.uri}/${currentBanner?.name}_${2400}x.avif") 1x type("image/avif"),
            url("${currentBanner?.uri}/${currentBanner?.name}_${2400}x.webp") 1x type("image/webp"),
            url("${currentBanner?.uri}/${currentBanner?.name}_${2400}x.jpg") 1x type("image/jpeg")
          )`,
          backgroundSize: currentBanner?.styles?.['backgroundSize'] ?? "cover",
          // ...(currentBanner?.styles ?? {}),
        }}
      >
        {/* { JSON.stringify(banners.map(banner => banner.name))} */}
        <Box
          sx={{
            opacity: showBannerDetails ? 1 : 0,
            transition: "opacity 300ms ease-in-out",
            borderRadius: "10px",
            textAlign: "start",
            position: "absolute",
            width: "fit-content",
            padding: 2,
            fontWeight: 400,
            bottom: 5,
            right: 5,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          {
            currentBanner?.uri?.length 
            ? (
              <Link to={currentBanner?.uri} style={{ color: 'white', textDecoration: 'none' }}>
                {currentBanner?.title}
              </Link>
          ) : (
            currentBanner?.title
          )}
        </Box>
      </div>
    </Box>
  );
};

function updateBanners(banners: Array<TaggedImage> | undefined, filters?: Array<Tag>) {
  if (typeof banners === 'undefined') {
    return [];
  }
  if (!filters) {
    return banners;
  }

  const filteredBanners = banners.filter(
    (banner) => !banner.tags.some((tag) => filters.includes(tag))
  );
  return filteredBanners;
}

function randomValue<T extends any>(array: Array<T>): T {
  return array[Math.floor(array.length * Math.random())];
}

function computeBanner(
  banners: Array<TaggedImage>,
  bannerTarget?: BannerTarget,
  variant?: number
): TaggedImage | null {
  
  let banner: TaggedImage | undefined;
  if (typeof bannerTarget === "string" && bannerTarget !== "random") {
    banner = banners.find((banner) => banner.name === bannerTarget);
  } else if (typeof bannerTarget === "number") {
    banner = banners[bannerTarget];
  }

  
  if (typeof banner !== "undefined") {
    return computeVariant(banner, banners, variant);
  }

  return computeVariant(randomValue(banners), banners);
}

function computeVariant(banner: TaggedImage, banners: Array<TaggedImage>, variant?: number): TaggedImage | null {
  if (!banner) {
    return null;
  }

  if (!banner.unifiedId || !banner.variant) {
    return banner;
  }

  banners = banners.filter(b => b.unifiedId === banner.unifiedId);

  return randomValue(banners);

  
  // if (typeof variant === "number") {
  //   partialBanner = banner.variants[variant];
  // } else {
  //   partialBanner = randomValue(banner.variants);
  // }

  // return banner;
  // return {
  //   ...banner,
  //   ...partialBanner,
  //   tags: [...banner.tags, ...(partialBanner.tags ?? [])],
  // };
}

export default Banner;
